import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=3d8c0fd2&scoped=true&"
import script from "./Warehouses.vue?vue&type=script&lang=ts&"
export * from "./Warehouses.vue?vue&type=script&lang=ts&"
import style0 from "./Warehouses.vue?vue&type=style&index=0&id=3d8c0fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8c0fd2",
  null
  
)

export default component.exports